export default __webpack_public_path__ + "static/media/triangle_up.f1e46ca4.svg";